import { render, staticRenderFns } from "./ContactHeader.vue?vue&type=template&id=56d8ec7a&"
import script from "./ContactHeader.vue?vue&type=script&lang=js&"
export * from "./ContactHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Address: require('/vercel/path0/components/profile/Address.vue').default,ArrowLink: require('/vercel/path0/components/general/ArrowLink.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default})
